import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as api from '../../api/index';
import { Container, Paper, Title, Text, Loader, Button, Group } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

export default function ThankYou() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get('order_id');

  const [status, setStatus] = useState(orderId ? 'verifying' : 'success'); // If no check needed, assume success (cod)
  const [retries, setRetries] = useState(0);

  useEffect(() => {
    if (!orderId) return;

    const pollStatus = async () => {
      try {
        const { data } = await api.commonFetch(`/orders/${orderId}`);
        console.log("Polling Order Status:", data.status);

        if (data.status === 'PAID') {
          setStatus('success');
        } else if (retries < 10) { // Poll for ~20 seconds
          setTimeout(() => {
            setRetries(prev => prev + 1);
          }, 2000); // Retry every 2s
        } else {
          setStatus('pending'); // Timeout, but might still be processing
        }
      } catch (error) {
        console.error("Error polling order:", error);
      }
    };

    if (status === 'verifying') {
      pollStatus();
    }
  }, [orderId, retries, status]);


  return (
    <Container size="sm" style={{ height: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

      {status === 'verifying' && (
        <Paper p="xl" radius="md" withBorder style={{ textAlign: 'center' }}>
          <Loader size="xl" variant="dots" mb="md" />
          <Title order={3}>Verifying Payment...</Title>
          <Text color="dimmed">Please wait while we confirm your transaction.</Text>
        </Paper>
      )}

      {status === 'success' && (
        <Paper p="xl" radius="md" withBorder style={{ textAlign: 'center', borderColor: 'green' }}>
          <IconCheck size={60} color="green" style={{ marginBottom: 20 }} />
          <Title order={2} mb="sm">Order Placed Successfully! ❤️</Title>
          <Text size="lg" mb="xl">
            Thank you for ordering from us.<br />
            You will receive updates regarding delivery and tracking via SMS.
          </Text>
          <Link to="/">
            <Button variant="outline" color="dark">Go to Home</Button>
          </Link>
        </Paper>
      )}

      {status === 'pending' && (
        <Paper p="xl" radius="md" withBorder style={{ textAlign: 'center', borderColor: 'orange' }}>
          <Title order={3} mb="sm">Payment Processing</Title>
          <Text color="dimmed" mb="xl">
            We haven't received the confirmation yet, but don't worry. <br />
            If the amount was deducted, your order will be updated automatically.
          </Text>
          <Group position="center">
            <Button variant="subtle" onClick={() => window.location.reload()}>Check Again</Button>
            <Link to="/">
              <Button variant="outline" color="dark">Go to Home</Button>
            </Link>
          </Group>
        </Paper>
      )}

    </Container>
  );
}
